import React from 'react';
import { motion } from 'framer-motion';
import '../../assets/styles/PortfolioSection.css';

import sfrLogo    from '../../assets/images/sfranalyzer-logo.svg';
import sfrShot    from '../../assets/images/sfranalyzer-ss1.PNG';
import cwLogo     from '../../assets/images/carleneswindowtreatments-logo.png';
import cwShot     from '../../assets/images/carleneswindowtreatmentss1.PNG';
import pscShot    from '../../assets/images/pureseatcomfort-ss1.png';
import pscLogo    from '../../assets/images/pureseatcomfort-logo.png';

const items = [
  {
    title: 'SFR Analyzer',
    pkg:   'Authority',
    desc:  'A Section 8 real estate investment calculation tool where investors log in and save their portfolio.',
    logo:  sfrLogo,
    shot:  sfrShot,
    link:  'sfranalyzer.com',
    href:  'https://sfranalyzer.com',
  },
  {
    title: "Carlene's Window Treatments",
    pkg:   'Authority',
    desc:  'A custom window-treatment business. Customers log in and configure their windows through custom logic.',
    logo:  cwLogo,
    shot:  cwShot,
    link:  'carleneswindowtreatments.com',
    href:  'https://carleneswindowtreatments.com/',
  },
  {
    title: 'Pure Seat Comfort',
    pkg:   'Custom',
    desc:  'A premium ergonomic seat cushion brand. A fully custom e-commerce site built to convert visitors into buyers.',
    logo:  pscLogo,
    shot:  pscShot,
    link:  'pureseatcomfort.com',
    href:  'https://pureseatcomfort.com',
  },
];

const PortfolioSection = () => (
  <motion.section
    id="portfolio"
    className="portfolio-section section alt"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, ease: 'easeOut' }}
    viewport={{ once: true, amount: 0.1 }}
  >
    <div className="section-inner">
      <p className="eyebrow centered">Selected work</p>
      <h2 className="centered">Our work</h2>

      <div className="portfolio-grid">
        {items.map((item, i) => (
          <motion.div
            key={item.title}
            className="portfolio-item"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 + i * 0.12 }}
            viewport={{ once: true, amount: 0.1 }}
          >
            <div className="portfolio-head">
              {item.logo
                ? <img className="portfolio-logo" src={item.logo} alt={item.title} />
                : <span className="portfolio-title-text">{item.title}</span>
              }
              <span className="pill-tag">{item.pkg}</span>
            </div>
            <h3>{item.title}</h3>
            <p className="body-lora">{item.desc}</p>
            <div className="portfolio-shot">
              <img src={item.shot} alt={`${item.title} screenshot`} />
            </div>
            <a className="portfolio-link" href={item.href} target="_blank" rel="noopener noreferrer">
              {item.link} →
            </a>
          </motion.div>
        ))}
      </div>
    </div>
  </motion.section>
);

export default PortfolioSection;
